"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const eventsAreLegacyEvents = (events) => (0, ts_validators_1.valueIsArray)(events);
exports.default = eventsAreLegacyEvents;
